import styled from 'styled-components';

import { mobile, tablet, desktop } from 'utils/media';
import theme from 'utils/theme';

interface BackgroundProps {
  colorScheme?: {
    background?: string;
    text?: string;
  };
}

export const Background = styled.div<BackgroundProps>`
  background-color: ${(props) =>
    theme.colors[props.colorScheme?.background || 'irisPurple']};
  color: ${(props) => theme.colors[props.colorScheme?.text || 'white']};
  font-size: var(--step-2);
`;

export const Title = styled.div`
  font-weight: ${theme.weights.bold};

  ${mobile} {
    border-right: 1px solid currentColor;
    padding-right: var(--space-m);
    padding-bottom: var(--space-3xl);
  }

  ${tablet} {
    margin-bottom: var(--space-3xl);
  }

  ${desktop} {
    h1,
    h2,
    h3,
    h4,
    p,
    blockquote {
      max-width: 50%;
    }
  }

  img {
    max-width: 100%;
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const TreeContainer = styled.div`
  overflow: hidden;

  ${mobile} {
    border-right: 1px solid currentColor;
  }
`;

export const Tree = styled.div`
  column-gap: var(--space-6xl);
  column-rule: 1px solid currentColor;

  ${tablet} {
    margin-top: -1px;
    column-count: 2;
  }

  figure {
    margin-bottom: var(--space-l-xl);
  }

  > div {
    padding: var(--site-gutter) var(--space-m) var(--site-gutter) 0;
    break-inside: avoid;
    position: relative;

    ${tablet} {
      padding: var(--site-gutter) 0;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: calc(var(--space-6xl) / -2);
      right: calc(var(--space-6xl) / -2);
      height: 1px;
      background-color: currentColor;
    }

    > p:first-child {
      margin-top: 0;
    }

    > p:last-child {
      margin-bottom: 0;
    }
  }
`;
